import React, { useState, useEffect } from 'react';
import {
  Container, Row, Col, Card, Button, Form,
  Table, Badge, Spinner, Alert, ListGroup
} from 'react-bootstrap';
import moment from 'moment';
import { obtenerPlantillaUnica, actualizarPlantillaUnica, subirArchivoStorage, eliminarArchivoStorage } from '../../api/common';
import extraerNombreArchivo from './extraerNombreArchivoFirebase';

const CAMPOS_FORM = [
  { key: 'nombre',                 label: 'Nombre del formato',      type: 'text',   md: 6 },
  { key: 'titulo',                 label: 'Título del documento',    type: 'text',  md: 6 },
  { key: 'codigo',                 label: 'Código Formato',          type: 'text',  md: 6 },
  { key: 'versionactual',          label: 'Versión Actual Formato',  type: 'number', min: 1, md: 6 },
  { key: 'formato_consecutivo',    label: 'Formato Consecutivo',     type: 'text',  md: 6 },
  { key: 'numero_consecutivo',     label: 'Número Consecutivo',      type: 'number', md: 6 },
  { key: 'mensaje_inicial',        label: 'Mensaje Inicial',         type: 'textarea', md: 12 },
  { key: 'condiciones_pago',       label: 'Condiciones de Pago',     type: 'text', md: 12 },
  { key: 'observaciones',          label: 'Observaciones',           type: 'textarea', md: 12 },
  { key: 'dias_vigencia',          label: 'Días de Vigencia',        type: 'number', min: 1, md: 12 },

];

const INITIAL_FORM = {
  nombre: 'Propuesta Comercial',
  titulo: 'Propuesta Comercial',
  codigo: 'MIS-CGO-001', //mayusculas, sin espacios, para usar en el nombre del archivo PDF generado al descargar la propuesta
  versionactual: 1,
  mensaje_inicial: 'Estimado cliente, adjuntamos nuestra propuesta comercial para su consideración.',
  condiciones_pago: '50% anticipo y 50% al finalizar',
  tiempo_entrega: '10 días hábiles',
  terminos_condiciones: '',
  observaciones: '',
  dias_vigencia: 30,
  formato_consecutivo: 'C-1-',
  numero_consecutivo: 1

};

const ConfigPlantillaPropuesta = () => {
  const [formData, setFormData]     = useState(INITIAL_FORM);
  console.log('FormData:', formData);
  const [versiones, setVersiones]   = useState([]);
  const [fileAdj, setFileAdj]       = useState([]); // URLs de archivos adjuntos a la plantilla
  const [plantillaId, setPlantillaId] = useState(null);
  const [loading, setLoading]       = useState(false);
  const [loadingInit, setLoadingInit] = useState(true);
  const [uploadingFile, setUploadingFile] = useState(false);
  const [mensaje, setMensaje]       = useState(null);
  const [showHistorial, setShowHistorial] = useState(false);

  useEffect(() => { cargarPlantilla(); }, []);

  const cargarPlantilla = async () => {
    setLoadingInit(true);
    try {
      const res = await obtenerPlantillaUnica();
      const p   = res.data?.data;
      if (p) {
        setPlantillaId(p._id);
        const datos = {};
        CAMPOS_FORM.forEach(c => { datos[c.key] = p[c.key] ?? INITIAL_FORM[c.key]; });
        setFormData(datos);
        setFileAdj(p.fileAdj || []);
        // Versiones más recientes primero
        setVersiones([...(p.versiones || [])].reverse());
      }
    } catch {
      setMensaje({ tipo: 'danger', texto: 'Error al cargar la plantilla' });
    }
    setLoadingInit(false);
  };

  const handleChange = (campo, valor) => {
    setFormData(prev => ({ ...prev, [campo]: valor }));
  };

  const handleGuardar = async () => {
    setLoading(true);
    setMensaje(null);
    try {
      const res = await actualizarPlantillaUnica({ ...formData, fileAdj });
      const p   = res.data?.data;
      if (p) {
        setPlantillaId(p._id);
        setFileAdj(p.fileAdj || []);
        setVersiones([...(p.versiones || [])].reverse());
      }
      setMensaje({ tipo: 'success', texto: 'Plantilla guardada correctamente' });
    } catch {
      setMensaje({ tipo: 'danger', texto: 'Error al guardar la plantilla' });
    }
    setLoading(false);
  };

  const handleAdjuntarArchivo = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setUploadingFile(true);
    try {
      const res = await subirArchivoStorage(file, 'plantillas');
      const url = res.data?.url;
      if (url) {
        const nuevosAdj = [...fileAdj, url];
        setFileAdj(nuevosAdj);
        // Guardar inmediatamente para persistir el campo fileAdj es un array y no un campo separado, se actualiza toda la plantilla con el nuevo array de adjuntos
      
       const result = await actualizarPlantillaUnica({ ...formData, fileAdj: nuevosAdj });
        setMensaje({ tipo: 'success', texto: 'Archivo adjuntado correctamente' });
      }
    } catch {
      setMensaje({ tipo: 'danger', texto: 'Error al adjuntar el archivo' });
    }
    setUploadingFile(false);
    // limpiar input
    e.target.value = '';
  };

  const handleEliminarAdj = async (url) => {
    if (!window.confirm('¿Eliminar este archivo de la plantilla?')) return;
    setUploadingFile(true);
    try {
      await eliminarArchivoStorage(url);
      const nuevosAdj = fileAdj.filter(u => u !== url);
      setFileAdj(nuevosAdj);
      await actualizarPlantillaUnica({ ...formData, fileAdj: nuevosAdj });
      setMensaje({ tipo: 'success', texto: 'Archivo eliminado' });
    } catch {
      setMensaje({ tipo: 'danger', texto: 'Error al eliminar el archivo' });
    }
    setUploadingFile(false);
  };

  if (loadingInit) {
    return (
      <Container fluid className="py-5 text-center">
        <Spinner animation="border" />
        <p className="mt-2 text-muted">Cargando plantilla…</p>
      </Container>
    );
  }

  return (
    <Container fluid className="py-3">
      <div className="d-flex align-items-center mb-3 gap-2">
        <h4 className="mb-0">Plantilla de Propuesta Comercial</h4>
        <Badge bg="success">Única</Badge>
      </div>
      <p className="text-muted small mb-3">
        Esta es la plantilla global utilizada al crear nuevas propuestas.
        Cada vez que guardes se registra una versión en el historial.
      </p>

      {mensaje && (
        <Alert variant={mensaje.tipo} dismissible onClose={() => setMensaje(null)}>
          {mensaje.texto}
        </Alert>
      )}

      <Row>
        {/* FORMULARIO */}
        <Col md={12}>
          <Card className="w-100 shadow-sm w-100">
            <Card.Header className='w-100'>
              <h6 className="mb-0">
                <i className="bi bi-pencil-square me-2"></i>
                {plantillaId ? 'Editar Plantilla' : 'Crear Plantilla'}
              </h6>
            </Card.Header>

            <Card.Body className='w-100'>
              <Row className="g-3">
              {CAMPOS_FORM.map(campo => (
                <Col md={campo.md || 12} key={campo.key}>
                  <Form.Group className="mb-3">
                    <Form.Label className="mb-1" style={{ fontSize: '0.85rem' }}>
                      {campo.label}
                    </Form.Label>
                    {campo.type === 'textarea' ? (
                    <Form.Control
                      as="textarea"
                      rows={3}
                      value={formData[campo.key]}
                      onChange={e => handleChange(campo.key, e.target.value)}
                    />
                  ) : 
                  (
                    <Form.Control
                      type={campo.type}
                      value={formData[campo.key]}
                      onChange={e =>
                        handleChange(
                          campo.key,
                          campo.type === 'number' ? Number(e.target.value) : e.target.value
                        )
                      }
                      min={campo.min}
                      max={campo.max}
                    />
                  ) }
                </Form.Group>
              </Col>
              ))}

              <Button variant="primary" onClick={handleGuardar} disabled={loading}>
                {loading
                  ? <><Spinner size="sm" animation="border" className="me-1" />Guardando…</>
                  : <><i className="bi bi-save me-1"></i>Guardar</>
                }
              </Button>
                </Row>
            </Card.Body>
          </Card>
        </Col>

        {/* DOCUMENTOS ADJUNTOS */}
        <Col md={12} className="mb-3">
          <Card className="w-100 shadow-sm w-100">
            <Card.Header className='w-100'>
              <strong><i className="bi bi-paperclip me-2"></i>Documentos Adjuntos a la Plantilla</strong>
            </Card.Header>
            <Card.Body className='w-100'>
              <p className="text-muted small mb-2">
                Estos archivos se copian a cada nueva propuesta para que el cliente los descargue
                (formatos ISO 17025, planillas, etc.).
              </p>
              <div className="d-flex align-items-center gap-2 mb-3">
                <Form.Control
                  type="file"
                  accept=".jpg,.jpeg,.png,.pdf,.xlsx,.xls,.doc,.docx"
                  onChange={handleAdjuntarArchivo}
                  disabled={uploadingFile}
                  style={{ maxWidth: 320 }}
                />
                {uploadingFile && (
                  <Spinner animation="border" size="sm" variant="primary" />
                )}
              </div>
              {fileAdj.length === 0 ? (
                <p className="text-muted small mb-0">Sin archivos adjuntos.</p>
              ) : (
                <ListGroup variant="flush">
                  {fileAdj.map((url, idx) => {
                    const nombre = extraerNombreArchivo(url) || `Adjunto ${idx + 1}`;
                    return (
                      <ListGroup.Item key={idx} className="d-flex align-items-center justify-content-between px-0">
                        <a href={url} target="_blank" rel="noreferrer" className="text-truncate me-2" style={{ maxWidth: '75%' }}>
                          <i className="bi bi-file-earmark me-1"></i>{nombre}
                        </a>
                        <Button
                          variant="outline-danger"
                          size="sm"
                          disabled={uploadingFile}
                          onClick={() => handleEliminarAdj(url)}
                        >
                          <i className="bi bi-trash"></i>
                        </Button>
                      </ListGroup.Item>
                    );
                  })}
                </ListGroup>
              )}
            </Card.Body>
          </Card>
        </Col>

        {/* HISTORIAL DE VERSIONES */}
        <Col md={12}>
          <Card className="w-100 shadow-sm w-100">
            <Card.Header
              className="d-flex justify-content-between align-items-center w-100"
              style={{ cursor: 'pointer' }}
              onClick={() => setShowHistorial(v => !v)}
            >
              <h6 className="mb-0">
                <i className="bi bi-clock-history me-2"></i>
                Historial de versiones
                {versiones.length > 0 && (
                  <Badge bg="secondary" className="ms-2">{versiones.length}</Badge>
                )}
              </h6>
              <i className={`bi bi-chevron-${showHistorial ? 'up' : 'down'}`}></i>
            </Card.Header>

            {showHistorial && (
              <Card.Body className="p-0 w-100">
                {versiones.length === 0 ? (
                  <p className="text-muted text-center py-3 mb-0">
                    Aún no hay versiones registradas.
                    El historial se genera al guardar cambios.
                  </p>
                ) : (
                  <div style={{ maxHeight: '420px', overflowY: 'auto' }}>
                    <Table size="sm" bordered hover className="mb-0">
                      <thead className="table-light" style={{ position: 'sticky', top: 0 }}>
                        <tr>
                          <th>Fecha</th>
                          <th>Guardado por</th>
                          <th>IVA</th>
                          <th>Vigencia</th>
                          <th>Condiciones pago</th>
                        </tr>
                      </thead>
                      <tbody>
                        {versiones.map((v, idx) => (
                          <tr key={v._id || idx}>
                            <td style={{ whiteSpace: 'nowrap', fontSize: '0.8rem' }}>
                              {moment(v.fecha).format('DD/MM/YY HH:mm')}
                            </td>
                            <td style={{ fontSize: '0.8rem' }}>
                              {v.modificado_por
                                ? `${v.modificado_por.nombre} ${v.modificado_por.apellido}`
                                : '—'}
                            </td>
                            <td className="text-center" style={{ fontSize: '0.8rem' }}>
                              {v.snapshot?.porcentaje_iva_default ?? '—'}%
                            </td>
                            <td className="text-center" style={{ fontSize: '0.8rem' }}>
                              {v.snapshot?.dias_vigencia ?? '—'} días
                            </td>
                            <td
                              style={{
                                fontSize: '0.75rem',
                                maxWidth: '160px',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap'
                              }}
                              title={v.snapshot?.condiciones_pago}
                            >
                              {v.snapshot?.condiciones_pago || '—'}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </div>
                )}
              </Card.Body>
            )}
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default ConfigPlantillaPropuesta;
